export default __webpack_public_path__ + "static/media/aceleraBrasilLogo.9481662b.png";